import { ArrowUpRight } from 'lucide-react'
import { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import AccordionServicos from './accordionServicos'
import BadgetOtimize from './badget-otimize'
import CardServicos from './cardServicos'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import Container from './container'

export function Impacto() {
  const { openModal } = useModal()
  const [openAccordionId, setOpenAccordionId] = useState(null)
  const servicosData = [
    {
      id: 1,
      icon: '../assets/icones/finep/icone-servico1.png',
      iconHover: '../assets/gestao-icone.png',
      title: 'Acesso a financiamento',
      text: 'As empresas têm acesso a recursos financeiros expressivos para impulsionar projetos inovadores, reduzindo riscos e potencializando investimentos.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 2,
      icon: '../assets/icones/finep/icone-servico2.png',
      iconHover: '../assets/icone-suporte.png',
      title: 'Aceleração da inovação',
      text: 'Gerenciamos os projetos de inovação para que sejam desenvolvidos de forma ágil e eficiente, gerando produtos e serviços com vantagens competitivas significativas.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 3,
      icon: '../assets/icones/finep/icone-servico3.png',
      iconHover: '../assets/icone-risco.png',
      title: 'Melhoria na gestão da  inovação',
      text: 'Com nossa expertise e suporte contínuo, as empresas evoluem na gestão da inovação, garantindo que suas iniciativas estejam alinhadas aos objetivos estratégicos e operacionais.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 4,
      icon: '../assets/icones/finep/icone-servico4.png',
      iconHover: '../assets/gestao-icone.png',
      title: 'Maximização de resultados',
      text: 'Elevamos as chances de aprovação das propostas submetidas à FINEP, por conta da nossa expertise estratégica, maximizando o retorno sobre o investimento em inovação.',
      glowColor: '#FC00218C',
      url: '',
    },
  ]

  return (
    <div className="w-full bg-[rgb(15,7,57)] py-20 relative overflow-hidden text-white">
      <Container className="z-10">
        <h2 className="font-inter-light text-[32px] md:text-5xl lg:text-[60px] text-center mb-12">
          Impacto dos <br className="md:hidden" />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9]">
            nossos serviços
          </span>
        </h2>
        <div className="hidden relative md:block">
          <Carousel className="overflow-visible">
            <div className="flex justify-end absolute right-10 top-6 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
            <CarouselContent className="py-8">
              {servicosData.map((servico, index) => (
                <CarouselItem
                  key={index}
                  className="basis-full sm:basis-1/2 md:basis-1/2 lg:basis-1/3"
                >
                  <div className="relative overflow-visible">
                    <CardServicos {...servico} className="w-full" />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="relative ps-[2px] py-[2px] pe-px rounded-[30px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-fit mt-10 md:-mt-8">
            <div className="flex items-center gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[30px] text-white w-[350px]">
              <h3 className="w-fit font-inter-light">
                Otimize seu <br /> negócio!
              </h3>
              <button
                type="button"
                onClick={() => openModal(<FormularioRD />)}
                className="w-fit bg-white text-black text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
              >
                Contratar <ArrowUpRight className="size-5" />
              </button>
            </div>
          </div>
        </div>
        <div className="md:hidden space-y-4">
          {servicosData.map((servico, index) => (
            <div key={index} className="space-y-3">
              <button
                type="button"
                onClick={() =>
                  setOpenAccordionId(
                    openAccordionId === servico.id ? null : servico.id,
                  )
                }
                className="w-full"
              >
                <AccordionServicos
                  {...servico}
                  doesThereButton={false}
                  className="bg-[rgb(32,27,63)] backdrop-blur-[40px] text-left"
                />
              </button>
              {openAccordionId === servico.id && <BadgetOtimize />}
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
